




































































import { computed, defineComponent, ref } from '~/utils/nuxt3-migration'
import HeaderUserMenu from '~/components/car/header/HeaderUserMenu.vue'
import { formatNumber } from '~/utils/number'
import { useNamespacedStore } from '~/compositions/store'
import { USER_NS, UserState } from '~/store/modules/shared/user/state'
import { useUserAgent } from '~/compositions/user-agent'
import { ciUserCircle as ciUserCircleLight } from '~/icons/source/light/user-circle'
import { ciUserCircle as ciUserCircleSolid } from '~/icons/source/solid/user-circle'
import { ciMyClassifieds } from '~/icons/source/regular/my-classifieds'
import { useGlobalElements } from '~/compositions/global-elements'
import CAvatar from '~/components/shared/configurable/image/avatar/CAvatar.vue'

export default defineComponent({
  components: {
    CAvatar,
    HeaderUserMenu
  },
  setup() {
    const { state, getters } = useNamespacedStore<UserState>(USER_NS)
    const { isPc } = useUserAgent()

    const shown = ref(false)
    const isModalVisible = ref(false)

    const { showAccountIndicator } = useGlobalElements()

    const avatar = computed(() => state.avatar)
    const username = computed(() => state.username)
    const isAnon = computed(() => getters('isAnon'))
    const isSingle = computed(() => getters('isSingle'))
    const isSingleOrAnon = computed(() => getters('isSingleOrAnon'))
    const totalCredits = computed(() => getters('totalCredits'))
    const totalCreditsFormatted = computed(() =>
      formatNumber(totalCredits.value)
    )

    function enter() {
      if (!isPc.value) return
      shown.value = true
    }
    function leave() {
      shown.value = false
    }

    function handleClickUser(e: Event) {
      if (isSingleOrAnon.value && !isPc.value) {
        e.preventDefault()
        isModalVisible.value = true
      }

      if (userTo.value && shown.value) {
        shown.value = false
      }
    }

    const userTo = computed(() => {
      if (isAnon.value) {
        return {
          name: '__login'
        }
      } else if (isSingle.value) {
        return {
          name: '__classifieds_view',
          params: { slugOrId: username.value }
        }
      }

      return {
        name: '__account'
      }
    })

    return {
      ciUserCircleLight,
      ciUserCircleSolid,
      ciMyClassifieds,
      isAnon,
      avatar,
      username,
      showAccountIndicator,
      totalCredits,
      totalCreditsFormatted,
      isSingle,
      isSingleOrAnon,
      shown,
      isModalVisible,
      enter,
      leave,
      userTo,
      handleClickUser
    }
  }
})
